var upperCase = require('upper-case')
var snakeCase = require('snake-case')

/**
 * Constant case a string.
 *
 * @param  {string} value
 * @param  {string} [locale]
 * @return {string}
 */
module.exports = function (value, locale) {
  return upperCase(snakeCase(value, locale), locale)
}



//////////////////
// WEBPACK FOOTER
// ./~/constant-case/constant-case.js
// module id = 284
// module chunks = 0